// extracted by mini-css-extract-plugin
module.exports = {"Credits":"styles-module--Credits--xctb9","conclusion":"styles-module--conclusion--2_zC6","h6":"styles-module--h6--3B6aX","text3":"styles-module--text3--1XvAE"};